<template>
  <el-dialog
    title="Edit Template"
    :visible.sync="dialogVisible"
    width="1280px"
    top="0"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="g-group-edit"
    >
      <el-form-item label="Name" prop="name">
        <el-input
          v-model="ruleForm.name"
          style="width:1000px;"
          placeholder="Please input name"
        ></el-input>
      </el-form-item>
      <el-form-item label="Type" prop="type">
        <el-select
          v-model="ruleForm.type"
          placeholder="Please select type"
          style="width:1000px;"
        >
          <el-option
            v-for="item in type_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Subject" prop="subject">
        <el-input
          v-model="ruleForm.subject"
          style="width:1000px;"
          placeholder="Please input subject"
        ></el-input>
      </el-form-item>
      <el-form-item label="Content" prop="html_content">
        <div style="width:1000px;">
          <editor-bar
            v-model="ruleForm.html_content"
            :isClear="isClearEditor"
            @change="changeContent"
          ></editor-bar>
        </div>
      </el-form-item>
      <el-form-item label="Prompt" prop="gpt_prompt">
        <el-input v-model="ruleForm.gpt_prompt" placeholder="提示词.." type="textarea" rows="10" style="width:1000px;"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >Submit</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import EditorBar from "../public/_TinymceEditor";

export default {
  props: ["row"],
  components: {
    EditorBar,
  },
  data() {
    return {
      dialogVisible: true,
      isClearEditor:false,
      ruleForm: {
        id: 0,
        name:"",
        type:"",
        subject:"",
        html_content:"",
        gpt_prompt:"",
      },
      rules: {
        name: [
          { required: true, message: "Name can not be empty", trigger: "change" },
        ],
        type: [
          { required: true, message: "please select type", trigger: "change" },
        ],
        subject: [
          { required: true, message: "subject can not be empty", trigger: "change" },
        ],
        html_content: [
          { required: true, message: "content can not be empty", trigger: "change" },
        ],
      },
      //1:订单邮件；2:召回邮件；3:其他邮件
      type_options: [
        {value:1, label:"Orders"},
        {value:2, label:"Callback"},
        {value:3, label:"Others"},
      ],
    };
  },
  methods: {
    handleClose() {
      this.$parent.popName2 = null;
    },
    changeContent(val) {
      this.ruleForm.html_content = val;
    },
    submitForm(formName) {
      console.log(this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.commit("setLoading", { text: "正在保存.." });
          this.$http
            .post("/v1/pri/store-email-templates/save", this.ruleForm)
            .then((response) => {
              this.$store.commit("setLoading", { text: false });
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "Save success",
                  type: "success",
                });
                this.$parent.getList();
                setTimeout(() => {
                  this.handleClose();
                }, 1000);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            })
            .catch((error) => {
              this.$store.commit("setLoading", { text: false });
            });
        }
      });
    },
  },
  mounted() {
    if (this.row) {
      this.ruleForm = JSON.parse(JSON.stringify(this.row))
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/email/_pop_edit_templates.vue